import PropTypes from 'prop-types';
import CardInformationComponent from '../../components/card/CardInformationComponent';

const SectionsListComponent = ({ list, clicksection }) => {

    return (
        <div className='row flex flex-row flex-wrap'>

            {
                list.map(
                    (section, i) => {
                        return (<CardInformationComponent
                            key={`menuitem${i + 1}`}
                            name={section.nameEs}
                            bgimg={section.image}
                            size={1}
                            id={section.id}
                            click={clicksection} />)
                    }
                )
            }
        </div>
    )
}

SectionsListComponent.propTypes = {
    list: PropTypes.array,
    clicksection: PropTypes.func
}

export default SectionsListComponent;